import { render, staticRenderFns } from "./RecordingBar.vue?vue&type=template&id=51adc816&scoped=true&"
import script from "./RecordingBar.vue?vue&type=script&lang=ts&"
export * from "./RecordingBar.vue?vue&type=script&lang=ts&"
import style0 from "./RecordingBar.vue?vue&type=style&index=0&id=51adc816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51adc816",
  null
  
)

export default component.exports